export const licenseModals = {
  limitedAccess: {
    isDismissOnClick: false,
    modalFilename: 'LimitedAccess',
    title: 'modals:limitedAccessTitle'
  },
  welcome: {
    modalFilename: 'Welcome',
    settings: { viewedWelcome: true },
    isDismissOnClick: false
  },
  trialWelcome: {
    modalFilename: 'Welcome',
    title: 'modals:trialWelcome',
    settings: { viewedWelcome: true },
    isDismissOnClick: false
  },
  copyright: {
    modalFilename: 'CopyrightModal',
    title: 'copyright:modalHeader',
    isDismissOnClick: false
  }
};

export const licensingModals = {
  EXPIRED_LICENSE: 'ExpiredLicenseModal'
};
// TODO: fix typo in notificationModal
export const notificationModal = {
  refreshModal: {
    modalFilename: 'RefreshModal',
    title: 'modals:refresh',
    isDismissOnClick: false
  }
};
export const supportModals = {
  contactModal: {
    modalFilename: 'ContactUs',
    title: 'support:contact',
    isDismissOnClick: true
  },
  iconModal: {
    modalFilename: 'IconModal',
    title: 'support:iconLegend',
    isDismissOnClick: true
  }
};
